/* ----------------- React Native Paper --------------- */
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Card, List } from "react-native-paper";

/* ----------------- Hooks --------------- */
import { useAppTheme } from "../../../useAppTheme";

import Box from "../../Box";
import { CardIconHeader } from "../CardIconHeader";
import { FlatCard } from "../FlatCard";
/* ----------------- Components --------------- */
import { SummaryListItem } from "./SummaryListItem";

/* ----------------- Types --------------- */
import type { Distribution } from "../../../types";

/* -----------------Child components--------------- */
type ListItemData = {
	icon: string;
	title: string;
	description: string;
	chipLabel: string;
	iconColor?: string;
	key?: string;
	tooltip?: string;
};

type Section = {
	name: string;
	dist?: Distribution;
	list: ListItemData[];
};
type Props = {
	title: string;
	subtitle: string;
	tooltip?: string;
	data: Section[];
	handleClickInfo?: (text: string) => void;
};
export const ProgressSummaryCard = ({
	title,
	subtitle,
	data,
	tooltip,
	handleClickInfo,
}: Props) => {
	const theme = useAppTheme();
	const colorMap: Record<string, string> = {
		high: theme.palette.progress.high,
		medium: theme.palette.progress.medium,
		low: theme.palette.progress.low,
		skip: theme.palette.progress.noneBackground,
	};

	const Content = () => (
		<Card.Content
			style={{
				paddingHorizontal: 0,
				paddingBottom: 8,
			}}
		>
			{data.map(({ name, list }) => (
				<List.Section
					key={name}
					title={name}
					titleStyle={{
						fontFamily: "OpenSans-SemiBold",
					}}
				>
					{list.map(
						({
							description,
							chipLabel,
							iconColor,
							icon,
							key,
							title: listTitle,
							tooltip,
						}) => (
							<SummaryListItem
								key={listTitle}
								description={description}
								icon={icon}
								iconColor={iconColor || colorMap[`${key || ""}`]}
								chipLabel={chipLabel}
								title={listTitle}
								tooltip={tooltip}
							/>
						),
					)}
				</List.Section>
			))}
		</Card.Content>
	);

	return (
		<FlatCard>
			<Box paddingHorizontal={16} paddingTop={16} gap={8}>
				<Box flexDirection="row" alignItems="center" gap={8}>
					<CardIconHeader
						icon="book-open-outline"
						title={title}
						subtitle={subtitle}
					/>
					{tooltip && handleClickInfo ? (
						<Icon
							name="information-outline"
							size={16}
							color={theme.colors.onSurfaceVariant}
							onPress={() => handleClickInfo(tooltip)}
							accessibilityRole="button"
							accessibilityLabel="information"
						/>
					) : null}
				</Box>
			</Box>
			<Content />
		</FlatCard>
	);
};
